import { render, staticRenderFns } from "./officeScene.vue?vue&type=template&id=49ac65b7&scoped=true&"
import script from "./officeScene.vue?vue&type=script&lang=js&"
export * from "./officeScene.vue?vue&type=script&lang=js&"
import style0 from "./officeScene.vue?vue&type=style&index=0&id=49ac65b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac65b7",
  null
  
)

export default component.exports